export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Simple pluralizer function(only appending "s") not suitable for words like
 * leaf, life, knife, etc.
 * @param input the thing to pluralize
 * @param quantity the quantity of the things to pluralize
 * @param inclusive should the number be included into the output
 */
export const pluralize = (input: string, quantity: number, inclusive = false) =>
  `${inclusive ? `${quantity} ` : ''}${input}${quantity === 1 ? '' : 's'}`;

/**
 * Formats a number respecting the locale of the browser.
 * Numbers with decimals are rounded to the nearest integer.
 * @param n - The number to format
 * @returns The formatted number, or 0 if the number is null or undefined
 */
export const formatNumber = (n: number | null | undefined) => {
  const [locale] = navigator.language.split('@');
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(n ?? 0);
};
